import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function useMtTradeable(stockCode) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode,
    staleTime: 2500,
  });

  const isTradeable = data?.status_margin === 'ACTIVE';
  const isUntradeable = data?.status_margin !== 'ACTIVE';

  return { data, isSuccess, refetch, isTradeable, isUntradeable };
}

export default {
  useMtTradeable,
};
